var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclamationCircle = function SvgExclamationCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 76,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D2329",
    fillRule: "evenodd",
    d: "M38 76C17.013 76 0 58.987 0 38S17.013 0 38 0s38 17.013 38 38a38 38 0 0 1-38 38m0-74C18.118 2 2 18.118 2 38s16.118 36 36 36 36-16.118 36-36S57.882 2 38 2",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#009FDB",
    fillRule: "evenodd",
    d: "M37 55h2v2h-2zm0-36v31h2V19z",
    clipRule: "evenodd"
  })));
};
export default SvgExclamationCircle;